export default "__VITE_ASSET__D_TQr4yw__"